import React from 'react';

import { Text } from 'components/chroma';
import { productDisclosureStatementUrl } from 'scenes/common/helpers/contacts';

export const fusionBuilding = () => (
  <Text>
    Motor burn out cover for your Building will cover you for the reasonable
    cost of repairing or replacing electric motors that form part of your
    building (Up to $3,000 per incident). Examples of motors covered include
    electric motors in swimming pool pumps, ducted heating or air-conditioning
    units that are fixed to the building. Nominated Building excess applies. For
    full details, see the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);

export const fusionContents = () => (
  <Text>
    Motor burn out cover for your Contents will cover you for the reasonable
    cost of repairing or replacing electric motors that form part of your
    Contents (Up to $2,000 per incident). Some examples of motors covered
    include electric motors in freezers, refrigerators, washing machines, dryers
    and dishwashers. Nominated Contents excess applies. For full details, see
    the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);

export const accidentalDamage = () => (
  <Text>
    This covers you for accidental damage to your contents within your home.
    Some examples of accidental damage include red wine spilt onto carpet or
    damage to a painting that falls off the wall. Nominated Contents excess
    applies. For full details please read the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);

export const portableContents = () => (
  <Text>
    You can choose to cover your Portable contents Australia-wide – that is,
    inside your home, in the open air at your site and outside your site. This
    will provide cover for theft, loss or damage. A separate Portable contents
    cover excess applies. For full details please read the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);
